import { primaryKey, uuid } from 'drizzle-orm/pg-core';
import { Org } from './org';
import { tableBase } from '../utils';
export const orgId = uuid('org_id')
    .notNull()
    .references(() => Org.id);
export const orgTableBase = {
    ...tableBase,
    orgId,
    // createdById and updatedById reference the profile table, but we don't use a FK so clean up is easier
    createdById: uuid('created_by_id'),
    updatedById: uuid('updated_by_id'),
};
export const orgPrimaryKey = (table) => primaryKey({
    columns: [table.orgId, table.id],
});
//# sourceMappingURL=org-id.js.map